import React from 'react';
const NoDataSVG = ({ className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='163'
      height='130'
      viewBox='0 0 163 130'
      fill='none'
      className={className}
      {...props}
      onClick={onClick}
    >
      <circle cx='78.7539' cy='65' r='65' fill='#E6F3FD' />
      <path
        d='M124.348 63.223V100.25C124.348 107.943 118.091 114.2 110.296 114.2H45.2668C37.5741 114.2 31.3174 108.046 31.2148 100.353C31.2148 100.25 31.2148 100.25 31.2148 100.148V63.223C31.2148 63.1204 31.2148 63.1204 31.2148 63.0178C31.2148 62.8127 31.2148 62.6075 31.3174 62.4024C31.42 62.0947 31.5226 61.8896 31.6251 61.5819L49.0619 28.2469C49.6773 26.9135 51.0107 26.1955 52.4466 26.1955H103.013C104.449 26.1955 105.68 26.9135 106.398 28.2469L123.835 61.5819C123.937 61.787 124.04 62.0947 124.142 62.4024C124.348 62.6075 124.348 62.9153 124.348 63.223Z'
        fill='#E6F3FD'
        stroke='#BFD6FA'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <path
        d='M103.136 12.725C104.474 27.3382 105.143 30.6848 102.113 43.919C101.127 46.8612 100.142 50.0837 98.0295 52.3254C95.0727 55.8281 89.7223 57.3692 85.3575 56.2484C80.8519 55.1275 77.1911 51.2045 76.3463 46.4409C75.6423 43.4987 76.6279 39.996 79.1623 38.1746C81.8375 36.4933 85.6391 36.9137 87.8919 39.0153C90.4263 41.1169 91.4119 44.3393 91.2711 47.4217C91.1303 50.504 90.0039 53.5864 88.4551 56.2484C84.9539 62.794 83.5125 62.7699 76.3463 73.5202'
        stroke='#8CC2F6'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeDasharray='4 4'
      />
      <path
        d='M110.985 7.28257C110.45 9.23528 108.309 9.94536 106.168 8.70272C103.849 7.63761 102.244 6.75002 102.6 4.97483C103.136 3.19963 105.276 3.02212 107.774 2.8446C110.807 2.48956 111.342 5.32986 110.985 7.28257Z'
        fill='#BFD6FA'
      />
      <path
        d='M93.6828 9.05752C94.5748 10.6552 97.0724 11.7203 98.8564 10.1226C100.819 8.34745 102.424 7.10481 101.532 5.32962C100.64 3.73195 99.2132 4.26451 96.1804 4.61955C93.6828 5.1521 92.6125 7.28233 93.6828 9.05752Z'
        fill='#BFD6FA'
      />
      <path
        d='M101.531 2.48967C102.78 2.31215 104.029 3.02223 104.386 4.08734C104.564 4.44238 104.743 4.97494 104.743 5.32998C105.099 7.81524 104.207 9.94547 102.78 10.123C101.175 10.478 99.569 8.70284 99.3906 6.39509C99.3906 5.68501 99.3906 5.32998 99.3906 4.79742C99.569 3.55479 100.283 2.66719 101.531 2.48967C101.71 2.48967 101.531 2.48967 101.531 2.48967Z'
        fill='#8CC2F6'
      />
      <path
        d='M124.348 63.223V104.045C124.348 109.687 119.835 114.2 114.091 114.2H41.4718C35.8305 114.2 31.2148 109.687 31.2148 104.045V63.0178C31.2148 62.8127 31.2148 62.6076 31.3174 62.4024H54.7032C58.1905 62.4024 61.0625 65.1718 61.0625 68.7617C61.0625 70.5054 61.7804 72.1465 62.9087 73.2747C64.1395 74.5056 65.5755 75.121 67.4217 75.121H88.2433C91.7306 75.121 94.6026 72.3516 94.6026 68.7617C94.6026 67.018 95.3205 65.3769 96.4488 64.2487C97.6796 63.0178 99.1156 62.4024 100.859 62.4024H124.142C124.348 62.6076 124.348 62.9153 124.348 63.223Z'
        fill='#E6F3FD'
        stroke='#B9DBFA'
        strokeWidth='2'
        strokeMiterlimit='10'
      />
      <circle cx='17.535' cy='20.842' r='4.07407' fill='#E6F3FD' />
      <circle cx='137.832' cy='21.9346' r='4.07376' fill='#E6F3FD' />
      <circle cx='4.07376' cy='105.738' r='4.07376' fill='#E6F3FD' />
      <circle cx='13.1985' cy='122.033' r='6.40163' fill='#E6F3FD' />
      <circle cx='155.058' cy='99.5451' r='7.22222' fill='#E6F3FD' />
      <ellipse
        cx='140.983'
        cy='107.694'
        rx='3.51852'
        ry='3.51852'
        fill='#E6F3FD'
      />
      <path
        d='M151.486 77.2608L152.62 82.6191L157.902 83.7697L152.62 84.9204L151.486 90.2786L150.352 84.9204L145.07 83.7697L150.352 82.6191L151.486 77.2608Z'
        fill='white'
      />
    </svg>
  );
};

export default NoDataSVG;
